import axios from 'axios';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    // 'x-api-key': process.env.REACT_APP_API_KEY   ❌ removed
  }
});

// ✅ REQUEST INTERCEPTOR (attach token)
httpClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

httpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {

      //localStorage.setItem("redirectAfterLogin", window.location.pathname);

      // Read user role before clearing storage
      let userRole = "";

      try {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        userRole = userDetails && userDetails.role ? userDetails.role : "";
      } catch (e) {
        userRole = "";
      }
      const currentUrl =
      window.location.pathname +
      window.location.search +
      window.location.hash;

      localStorage.setItem("redirectAfterLogin", currentUrl);
      // Clear storage
      localStorage.removeItem("token");
      localStorage.removeItem("userDetails");

      // Remove interactionData only if user is NOT a market user
      // if (userRole !== "MARKET") {
      //   localStorage.removeItem("interactionData");
      // }

      localStorage.removeItem("previousMarket");
      localStorage.removeItem("salesArea");
      localStorage.removeItem("selectedMarketLang");
      localStorage.removeItem("store");
      localStorage.removeItem("uniqueID");
      localStorage.removeItem("tokenGeneratedAt");
      localStorage.removeItem("tokenExpiresIn");
      localStorage.removeItem('tokenExpiry');

      // Redirect
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);
// ✅ APIs
export const fetchPPSIS = (org) => httpClient.get(`/${org}/ppsis`);

export const fetchPPIS = (org) => httpClient.get(`/${org}/ppis`);

export const fetchConfig = (org) => httpClient.get(`/${org}/config`);

export const fetchRefresh = (org) => httpClient.get(`/${org}/ppsirefresh`);

export const saveInteractionsCount = (data) =>
  httpClient.post(`/kitchen/coworker/saveinteractioncount`, data);

export const fetchMarket = (org) =>
  httpClient.get(`/config/allconfigmarketsppsilanguagecode`);

export const getCaptcha = (org, data) =>
  httpClient.post(`/${org}/generateCaptcha`, data);

export const saveFeedback = (org, data) =>
  httpClient.post(`/${org}/saveCoworkerFeedback`, data);

export const cancelFeedback = (clientId) =>
  httpClient.post(`/${clientId}/cancel`);

export default httpClient;